import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getThemeTokens, shellMetrics } from '../tokens';

export const styledBackstageSidebarDivider = (
  theme: Theme,
): BackstageOverrides['BackstageSidebarDivider'] => ({
  root: {
    backgroundColor: getThemeTokens(theme).navigationBorder,
    border: 0,
    display: 'block',
    height: 1,
    margin: `${shellMetrics.railDividerGap}px ${shellMetrics.railOpenInset}px`,
    width: `calc(100% - ${shellMetrics.railOpenInset * 2}px)`,
  },
});
